import "./Footer.scss";
import tw from "./img/Twitter.png";
import is from "./img/Instagram.png";
import fb from "./img/Facebook.png";
import Modal from "react-modal";
import { useState } from "react";
import FooterModal from "./FooterModal";
const FootercustomStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)",
    overflow:"scroll",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    width:"90%",
    height:"100%",
    transform: "translate(-50%, -50%)",
    maxwidth: "inherit",
    background:"#f5f5f5",
   },
};

const Footer = () => {
  const [footerModalIsOpen, setFooterModalIsOpen] = useState(false);
  const closeModal = () =>{
    setFooterModalIsOpen(false);
    document.removeEventListener('click',closeModal)
  };
  
  const openModal = (event) =>{
    setFooterModalIsOpen(true);
    document.addEventListener('click',closeModal)
    event.stopPropagation()
  };


    const snsItem = [
        {
          name: "twitter",
          img: tw,
          url: "https://twitter.com/cha_hashi",
        },
        {
          name: "instagram",
          img: is,
          url: "https://www.instagram.com/church.hashimoto/",
        },
        {
          name: "facebook",
          img: fb,
          url: "https://www.facebook.com/profile.php?id=100046501539339",
        },
      ];
  return (
    <div className="Footer-container-main">
      <div className="Footer-wrapper">
        <div className="Footer-item">
            <div className="Footer-menu">
                <button onClick={(event)=>{openModal(event)}}>当サイトについて</button>
            </div>
            <div className="Footer-sns">
            <ul>
                {snsItem.map((snsItem) => (
                  <li>
                    <a target="_blank" rel="noopener noreferrer"  href={snsItem.url}>
                      <img src={snsItem.img}></img>
                    </a>
                  </li>
                ))}
              </ul>
              <Modal isOpen={footerModalIsOpen} style={FootercustomStyles}>
        < FooterModal/>
      </Modal>
            </div>
            <div className="Footer-tag">
                <p>©2022 Church hashimoto All Right Reserved.</p>
            </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
